import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../../api";

const initialState = {
  certificate: {
    currentPageSize: 20,
    currentPage: 1,
    search: "",
  },
  sortBy: "",
  sortOrder: "",
  search: "",
  showAddDrumBallModal: false,
  selectedCardId: "",
  selectedDrumBall: "",
  drumBallData: {
    Pending: [],
  },
  drumBallRecheckData: {
    Pending: [],
  },
  drumBallDataStatus: "idle",
  drumBallRecheckDataStatus: "idle",
  total: {
    Pending: "",
  },
  clear: false,
};

export const getDrumBallListData = createAsyncThunk(
  "employee/drumball",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post(
        `/employee-dashboard/order/assigned-to-me`,
        params,
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const getDrumBallRecheckListData = createAsyncThunk(
  "employee/drumball/recheck",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post(
        `/employee-dashboard/recheck/assigned-to-me`,
        params,
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

const mergeUnique = (existing, incoming) => {
  const seen = {};
  const merged = [];
  existing.forEach((item) => {
    seen[item._id] = true;
    merged.push(item);
  });
  incoming.forEach((item) => {
    if (!seen[item._id]) {
      seen[item._id] = true;
      merged.push(item);
    }
  });
  return merged;
};

const drumBallSlice = createSlice({
  name: "drumBall",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
  extraReducers: {
    [getDrumBallListData.pending]: (state) => {
      state.drumBallDataStatus = "pending";
    },
    [getDrumBallListData.fulfilled]: (state, action) => {
      const newData = action.payload.data.data.data;
      state.drumBallData.Pending = mergeUnique(
        state.drumBallData.Pending,
        newData,
      );
      state.total.Pending = action.payload.data.data.total_count;
      state.drumBallDataStatus = "fulfilled";
    },
    [getDrumBallListData.rejected]: (state) => {
      state.drumBallDataStatus = "failed";
    },
    [getDrumBallRecheckListData.pending]: (state) => {
      state.drumBallRecheckDataStatus = "pending";
    },
    [getDrumBallRecheckListData.fulfilled]: (state, action) => {
      const newData = action.payload.data.data.data;
      state.drumBallRecheckData.Pending = mergeUnique(
        state.drumBallRecheckData.Pending,
        newData,
      );
      state.total.Pending = action.payload.data.data.total_count;
      state.drumBallRecheckDataStatus = "fulfilled";
    },
    [getDrumBallRecheckListData.rejected]: (state) => {
      state.drumBallRecheckDataStatus = "failed";
    },
  },
});

export const { updateConfig } = drumBallSlice.actions;

export default drumBallSlice.reducer;
